// extracted by mini-css-extract-plugin
export var hamburger = "hamburger-module--hamburger--2318b";
export var hamburgerBox = "hamburger-module--hamburgerBox--235a5";
export var hamburgerCollapse = "hamburger-module--hamburgerCollapse--187a7";
export var hamburgerInner = "hamburger-module--hamburgerInner--66b83";
export var isActive = "hamburger-module--isActive--b4ebf";